import { 
    CreateRoomTypeDto, 
    DeleteRoomTypeDto,
    EditRoomTypeDto,
    GetRoomTypeDto, 
    MessageResponseDto, 
    RoomTypeApiFp,
    RoomTypeControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseRoomTypeModel = RoomTypeControllerGet200Response;
export type GetRoomTypeModel = GetRoomTypeDto;
export type MutateResponseRoomTypeModel = MessageResponseDto;
export type CreateRoomTypeModel = CreateRoomTypeDto;
export type UpdateRoomTypeModel = EditRoomTypeDto;
export type DeleteRoomTypeModel = DeleteRoomTypeDto;

export const apiRoomTypeFp = RoomTypeApiFp(apiConfig);
export const getRoomTypeController = apiRoomTypeFp.roomTypeControllerGet;
export const createRoomTypeController = apiRoomTypeFp.roomTypeControllerCreate;
export const updateRoomTypeController = apiRoomTypeFp.roomTypeControllerEdit;
export const deleteRoomTypeController = apiRoomTypeFp.roomTypeControllerDelete;

export const QueryKeyRoomType = QueryKey.RoomType;